import { Fragment } from "react";
import { LocalizedDateTime } from "../../components/LocalizedDate";
import { SKTButton } from "../../components/SKTButton";
import { SKTToggle } from "../../components/SKTToggle";
import { API_ENDPOINTS } from "../../config";
import { apiGET } from "../../hooks/APIHook";
import { popout } from "../../utils/popout";
import { Address } from "../../views/common/Address";
import { RawJSONTable } from "../components/RawJSONTable";
import { Table, TableBody, TableKeyValue } from "../components/Table";

export const Order = ({ order, refreshOrder, doReturn }) => {
  const showWaybill = () => {
    popout(API_ENDPOINTS.order.waybill(order.secret));
  };

  const showLabel = () => {
    popout(API_ENDPOINTS.order.label(order.secret));
  };
  const showInvoice = () => {
    popout(API_ENDPOINTS.order.invoice(order.secret));
  };

  const showStatus = () => {
    popout(`https://skt.bumax.fi/tilaus/?o=${order.secret}`);
  };
  const trackShipment = () => {
    popout(API_ENDPOINTS.order.trackShipment(order.secret));
  };
  const cancelOrder = () => {
    const url = API_ENDPOINTS.order.cancel(order.secret);

    apiGET(url).then((result) => {
      refreshOrder();
      if (result.status === "error") {
        alert(`TODO: Tilauksen peruutus ei onnistunut, syy ${result.reason}`);
      }
    });
  };

  return (
    <Fragment>
      <div class="container">
        <SKTButton label="&laquo; Palaa takaisin" onClick={doReturn} />
        <SKTButton label="Tilauksen yhteenvetosivu" onClick={showStatus} />
        <SKTButton label="Tilauksen seuranta" onClick={trackShipment} />
        <SKTButton label="Tilauksen kuitti" onClick={showInvoice} />
        <SKTButton
          label="Peruuta tilaus"
          type="btn-danger"
          onClick={cancelOrder}
        />
      </div>
      <Table>
        <TableBody>
          <TableKeyValue label="Tilausnumero">{order.number}</TableKeyValue>
          <TableKeyValue label="Tila">{order.status}</TableKeyValue>
          <TableKeyValue label="Asiakas">{order.customer?.name}</TableKeyValue>
          <TableKeyValue label="Mistä">
            <Address address={order.src} />
          </TableKeyValue>
          <TableKeyValue label="Minne">
            <Address address={order.dst} />
          </TableKeyValue>
          <TableKeyValue label="Tilaus luotu">
            <LocalizedDateTime datetime={order.created} />
          </TableKeyValue>
          <TableKeyValue label="Toivottu nouto">
            <LocalizedDateTime datetime={order.booking_date} />
          </TableKeyValue>
          <TableKeyValue label="Arvioitu nouto">
            <LocalizedDateTime datetime={order.pickup} />
          </TableKeyValue>
          <TableKeyValue label="Arvioitu toimitus">
            <LocalizedDateTime datetime={order.delivery} />
          </TableKeyValue>
          <TableKeyValue label="Rahtikirjan numero">
            {order.waybills?.id}
            <SKTToggle when={order.waybills.waybill}>
              <SKTButton onClick={showWaybill} label="Rahtikirja" />
            </SKTToggle>
            <SKTToggle when={order.waybills.label}>
              <SKTButton onClick={showLabel} label="Kollilaput" />
            </SKTToggle>
          </TableKeyValue>
          <TableKeyValue label="Sisältö">
            <RawJSONTable data={order.contents} />
          </TableKeyValue>
          <TableKeyValue label="Ostohinta">
            {order.price.buy}&nbsp;€
          </TableKeyValue>
          <TableKeyValue label="Myyntihinta">
            {order.price.total}&nbsp;€
          </TableKeyValue>
          <TableKeyValue label="ALV">{order.price.vat}&nbsp;€</TableKeyValue>
        </TableBody>
      </Table>
    </Fragment>
  );
};
